import * as actions from "../actions";

const initialState = {
  hasMetRequirements: null,
  hasProhibitionOrder: null,
  hasClosureOrder: null,
  businessName: null,
  premiseAddress: null,
  step: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_PREMISES_DETAILS:
      return {
        ...state,
        ...action.payload
      }
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    case actions.GET_APPLICATION_FULFILLED:
      return {
        ...action.payload.premisesDetails
      };
    default:
      return state
  }
}
